<template>
  <fragment>
    <common-header
      subname="교육 관리"
      name="강좌개설 초기값"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      v-bind:mainmenuOpened="true"
      :searchbox="false"
    ></common-header>

    <section ref="container" class="container">
      <common-side-menu :menus="side_menus"></common-side-menu>
      <!-- //end .side-nav -->

      <div class="container-fiuld class-making-box clearfix" v-if="selectedCategory">
        <div class="btn-group-box m-b-15 clearfix">
          <h3 class="f-18 text-nomal pull-left">{{selectedCategory.name}}</h3>
          <div class="pull-right m-b-15 clearfix">
            <button class="btn bg-deepblue text-white round" @click="save">저장</button>
          </div>
          <!-- //end .btn-group -->
        </div>
        <!-- //end .btn-group-box -->

        <div
          class="white-box head on-border bg-lightgray clearfix"
          style="margin-top: 0 !important;"
        >
          <p class="f-16 m-b-0 pull-left">기본설정</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox" checked>
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-10 pull-left">이미지</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="img-add">
            <input id="img" type="file" ref="file" @change="upload" />
            <label for="img">
              <img
                :src="lecData.lecIcon?'/download/'+lecData.lecIcon:'http://placehold.it/80x80'"
                alt
              />
            </label>
          </div>
          <ul class="img-guide">
            <li>이미지 등록 가이드1</li>
            <li>이미지 등록 가이드2</li>
            <li>이미지 등록 가이드3</li>
            <li>이미지 등록 가이드4</li>
          </ul>
        </div>
        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">강의실 설정</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5">강좌구성</p>
          <div class="input-group m-b-10">
            <span class="input-group-addon">
              <input
                id="chk_classroom_opt5"
                class="checkbox3-sm"
                type="checkbox"
                :checked="lecData.classroomOpt.indexOf('동영상 등록')>=0"
                @change="changeClassroomOpt('동영상 등록')"
              />
              <label for="chk_classroom_opt5" class="v-mid w200">동영상 등록</label>
            </span>
          </div>
          <p class="f-14 m-b-5">수료관리</p>
          <div class="input-group m-b-10">
            <span class="input-group-addon">
              <input
                id="chk_classroom_opt1"
                class="checkbox3-sm"
                type="checkbox"
                :checked="lecData.classroomOpt.indexOf('출결')>=0"
                @change="changeClassroomOpt('출결')"
              />
              <label for="chk_classroom_opt1" class="v-mid w100">출결</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="chk_classroom_opt2"
                class="checkbox3-sm"
                type="checkbox"
                :checked="lecData.classroomOpt.indexOf('시험')>=0"
                @change="changeClassroomOpt('시험')"
              />
              <label for="chk_classroom_opt2" class="v-mid w100">시험</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="chk_classroom_opt3"
                class="checkbox3-sm"
                type="checkbox"
                :checked="lecData.classroomOpt.indexOf('과제')>=0"
                @change="changeClassroomOpt('과제')"
              />
              <label for="chk_classroom_opt3" class="v-mid w100">과제</label>
            </span>
          </div>
          <p class="f-14 m-b-5">설문</p>
          <div class="input-group m-b-10">
            <span class="input-group-addon">
              <input
                id="chk_classroom_opt4"
                class="checkbox3-sm"
                type="checkbox"
                :checked="lecData.classroomOpt.indexOf('설문')>=0"
                @change="changeClassroomOpt('설문')"
              />
              <label for="chk_classroom_opt4" class="v-mid w100">설문</label>
            </span>
          </div>
        </div>
        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">강의목표 | 내용</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-10 pull-left">강의목표</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <input
            class="form-control round full-width text-left"
            type="text"
            placeholder="강의목표를 입력하세요."
            v-model="lecData.goal"
          />
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-10 pull-left">강의내용</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <textarea
            cols="30"
            rows="6"
            class="round full-width text-left"
            type="text"
            placeholder="강의내용를 입력하세요."
            v-model="lecData.content"
          ></textarea>
        </div>
        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">교육대상</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">신청인</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="round">
            <div class="input-group full-width">
              <span class="input-group-addon w160 v-mid text-white p-r-5">
                <select
                  class="form-control full-width round"
                  @change="addJob"
                  v-model="selectedJob"
                >
                  <option value="-1">=== 교육대상 직업군을 선택하세요 ===</option>
                  <option
                    v-for="(job, index) in jobs_"
                    :key="'job-list-'+hash(job)"
                    :index="index"
                    :value="index"
                  >{{job.codeNm}}</option>
                </select>
              </span>
              <span class="input-group-addon v-mid text-white">
                <div class="round on-border bg-white">
                  <div class="input-group p-5">
                    <span
                      class="input-group-addon"
                      v-for="job in jobs_.filter(job=>job.isSelected)"
                      :key="'selected-job-list-'+hash(job)"
                    >
                      {{ job.codeNm }}
                      <a class="m-r-5 text-blue text-bold" @click="removeJob(job)">×</a>
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">교육대상</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group m-b-10">
            <span class="input-group-addon">
              <input
                id="rdo_lestargetype_opt1"
                class="checkbox3-sm"
                type="radio"
                value="개인수강생"
                v-model="lecData.lesTargetType"
              />
              <label for="rdo_lestargetype_opt1" class="v-mid">개인수강생</label>
            </span>
            <span class="input-group-addon">
              <input
                id="rdo_lestargetype_opt2"
                class="checkbox3-sm"
                type="radio"
                value="단체수강생"
                v-model="lecData.lesTargetType"
              />
              <label for="rdo_lestargetype_opt2" class="v-mid m-l-5">단체수강생</label>
            </span>
          </div>
          <div class="round">
            <textarea class="full-width" cols="30" rows="10" v-model="lecData.lesTargetDetail"></textarea>
          </div>
        </div>
        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">담당자 | 강사</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">관리자</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <select
            class="w200 form-control-sm round m-b-0 m-r-5 pull-left"
            v-model="lecData.inCharge"
          >
            <option value>=== 관리 담당자를 선택하세요 ===</option>
            <option
              v-for="(admin, index) in admins_"
              :key="'admin-list-'+hash(admin)"
              :index="index"
              :value="admin.mberId"
            >{{admin.mberName}}</option>
          </select>
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">강사</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group m-b-30 full-width">
            <span class="input-group-addon">
              <input
                id="rdo_installottype_opt1"
                class="checkbox3-sm"
                type="radio"
                value="강사없음"
                v-model="lecData.instAllotType"
              />
              <label for="rdo_installottype_opt1" class="v-mid full-width">강사없음</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="rdo_installottype_opt2"
                class="checkbox3-sm"
                type="radio"
                value="강사지정"
                v-model="lecData.instAllotType"
              />
              <label for="rdo_installottype_opt2" class="v-mid full-width">강사지정</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="rdo_installottype_opt3"
                class="checkbox3-sm"
                type="radio"
                value="신청 후 배정"
                v-model="lecData.instAllotType"
              />
              <label for="rdo_installottype_opt3" class="v-mid full-width">신청 후 배정</label>
            </span>
          </div>
          <!-- 강사지정 -->
          <div class="input-group full-width m-b-10" v-if="lecData.instAllotType=='강사지정'">
            <span class="input-group-addon w180 left-round">
              <select class="form-control round full-width m-b-0">
                <option>강사</option>
              </select>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <div class="search-box full-width">
                <input
                  id="search"
                  class="form-control round full-width m-b-0"
                  type="text"
                  v-model="teacher_keyword"
                  @focusin="isFocus=true"
                />
                <label for="search">검색</label>
                <ul
                  class="search-list"
                  v-if="filteredTeachers.length>0"
                  :style="isFocus?'display:block':''"
                >
                  <li
                    v-for="(teacher, index) in filteredTeachers"
                    :key="'teacher-list-'+hash(teacher)+index"
                    :index="index"
                  >
                    <a
                      @click="appendTeacher(teacher)"
                    >{{teacher.mberName}}, {{teacher.mobileNum}}, {{teacher.email}}</a>
                  </li>
                </ul>
                <ul class="search-list" v-if="filteredTeachers.length==0">
                  <li>
                    <a @click="isFocus=false">==== 검색된 강사가 없습니다 ====</a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
          <div
            class="input-group full-width m-b-5"
            v-for="(teacher, index) in lecData.eduTemplList"
            :key="'selected-teacher-list-'+hash(teacher)+index"
            :index="index"
          >
            <span class="input-group-addon w180 left-round">
              <div
                class="round full-width on-border"
              >{{(teacher.instInfo&&teacher.instInfo.localKorInst)?teacher.instInfo.localKorInst:"강사"}}</div>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <div
                class="round full-width on-border"
              >{{teacher.mberName}}, {{teacher.mobileNum}}, {{teacher.email}}</div>
            </span>
            <span class="input-group-addon w60 p-l-5 v-mid">
              <button
                class="btn-sm btn-red round full-width"
                @click="lecData.eduTemplList.splice(lecData.eduTemplList.indexOf(teacher), 1)"
              >삭제</button>
            </span>
          </div>
        </div>
        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">신청 및 교육일정 | 정원</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">기본설정</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group">
            <span class="input-group-addon">
              <input
                id="rdo_eduperiodtype_opt1"
                class="checkbox3-sm"
                type="radio"
                value="교육일 지정"
                v-model="lecData.eduPeriodType"
              />
              <label for="rdo_eduperiodtype_opt1" class="v-mid w120">교육일 지정</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="rdo_eduperiodtype_opt2"
                class="checkbox3-sm"
                type="radio"
                value="수강생 신청"
                v-model="lecData.eduPeriodType"
              />
              <label for="rdo_eduperiodtype_opt2" class="v-mid w120">수강생 신청</label>
            </span>
            <span class="input-group-addon p-l-5">
              <input
                id="rdo_eduperiodtype_opt3"
                class="checkbox3-sm"
                type="radio"
                value="일정 선택"
                v-model="lecData.eduPeriodType"
              />
              <label for="rdo_eduperiodtype_opt3" class="v-mid w120">일정 선택</label>
            </span>
          </div>
        </div>

        <!-- 교육일정을 클릭했을때 노출 -->
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='교육일 지정'">
          <p class="f-14 m-b-5 pull-left m-b-10">신청기간</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="level m-b-0" style="width:80%;">
            <div class="level-form">
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD HH:mm'"
                  :minute-interval="10"
                  v-model="lecData.applStartDate"
                >
                  <input type="text" :value="lecData.applStartDate" />
                </VueCtkDateTimePicker>
              </span>
              <span class="text-center w20">~</span>
              <span class="date">
                <VueCtkDateTimePicker
                  :min-date="lecData.applStartDate"
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD HH:mm'"
                  :minute-interval="10"
                  v-model="lecData.applEndDate"
                >
                  <input type="text" :value="lecData.applEndDate" />
                </VueCtkDateTimePicker>
              </span>
            </div>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='교육일 지정'">
          <p class="f-14 m-b-5">신청 안내</p>
          <div class="round">
            <textarea class="full-width" name id cols="30" rows="10" v-model="lecData.applGuide"></textarea>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='교육일 지정'">
          <p class="f-14 m-b-5 pull-left m-b-10">교육기간</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="level m-b-0">
            <div class="level-form w300">
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD'"
                  :only-date="true"
                  :minute-interval="10"
                  v-model="lecData.lecEduDateTemplList[0].eduStartDate"
                >
                  <input type="text" :value="lecData.lecEduDateTemplList[0].eduStartDate" />
                </VueCtkDateTimePicker>
              </span>
              <span class="text-center w20">~</span>
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD'"
                  :only-date="true"
                  :minute-interval="10"
                  v-model="lecData.lecEduDateTemplList[0].eduEndDate"
                >
                  <input type="text" :value="lecData.lecEduDateTemplList[0].eduEndDate" />
                </VueCtkDateTimePicker>
              </span>
            </div>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='교육일 지정'">
          <p class="f-14 m-b-5 pull-left m-b-10">정원</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk-edudateopt-1-fixednum"
                class="checkbox3-sm"
                type="checkbox"
                name="eduFixedNum"
                :checked="lecData.lecEduDateTemplList[0].eduFixedNum!==0"
                @change="$event.target.checked===false?lecData.lecEduDateTemplList[0].eduFixedNum=0:''"
              />
              <label for="chk-edudateopt-1-fixednum" class="v-mid full-width m-0">정원있음</label>
            </span>
            <span class="input-group-addon p-l-5 clearfix">
              <input
                class="form-control-sm m-b-0 round pull-left"
                type="text"
                v-model="lecData.lecEduDateTemplList[0].eduFixedNum"
              />
              <span class="pull-left">(신청)건</span>
            </span>
          </div>
        </div>

        <!-- 수강생신청을 클릭했을때 노출 -->
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='수강생 신청'">
          <p class="f-14 m-b-5 pull-left m-b-10">신청기간</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <p class="f-12 m-b-0">신청시작일</p>
          <div class="level m-b-0">
            <div class="level-form w300">
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD HH:mm'"
                  :minute-interval="10"
                  v-model="lecData.applStartDate"
                >
                  <input type="text" :value="lecData.applStartDate" />
                </VueCtkDateTimePicker>
              </span>
            </div>
          </div>
          <p class="f-12 m-b-0">신청옵션</p>
          <div class="input-group m-b-5 full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk_eduperiodtype_2_applopt_1"
                class="checkbox3-sm"
                type="checkbox"
                name="applOpt1"
                v-model="lecData.applOpt.find(e=>e.name=='교육일자 기준').enabled"
              />
              <label for="chk_eduperiodtype_2_applopt_1" class="v-mid full-width m-0">교육일자 기준</label>
            </span>
            <span class="input-group-addon p-l-5 v-mid clearfix">
              <span class="pull-left m-l-5">교육시작일의</span>
              <input
                class="form-control-sm w80 m-l-5 m-b-0 round pull-left"
                type="text"
                v-model="lecData.applOpt.find(e=>e.name=='교육일자 기준').value"
              />
              <span class="pull-left m-l-5">일 전 까지</span>
            </span>
          </div>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk_eduperiodtype_2_applopt_2"
                class="checkbox3-sm"
                type="checkbox"
                name="applOpt2"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').enabled"
              />
              <label for="chk_eduperiodtype_2_applopt_2" class="v-mid full-width m-0">교육월 기준</label>
            </span>
            <span class="input-group-addon p-l-5 v-mid clearfix">
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').fromMonth"
              >
                <option value="지난달">지난달</option>
                <option value="지지난달">지지난달</option>
                <option value="3달전">3달전</option>
              </select>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').fromDate"
              >
                <option
                  v-for="(v,idx) in new Array(31)"
                  :key="'date-key-1-'+idx"
                  :value="idx+1"
                >{{idx+1}}일</option>
              </select>
              <span class="pull-left m-l-5">부터</span>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').toMonth"
              >
                <option value="지난달">지난달</option>
                <option value="지지난달">지지난달</option>
                <option value="3달전">3달전</option>
              </select>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').toDate"
              >
                <option
                  v-for="(v,idx) in new Array(31)"
                  :key="'date-key-2-'+idx"
                  :value="idx+1"
                >{{idx+1}}일</option>
              </select>
              <span class="pull-left m-l-5">까지</span>
            </span>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='수강생 신청'">
          <p class="f-14 m-b-5">신청 안내</p>
          <div class="round">
            <textarea class="full-width" name id cols="30" rows="10" v-model="lecData.applGuide"></textarea>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='수강생 신청'">
          <p class="f-14 m-b-5 pull-left m-b-10">교육기간</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <p class="f-12 m-b-0">신청가능기간</p>
          <div class="level m-b-0">
            <div class="level-form w300">
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD'"
                  :only-date="true"
                  :minute-interval="10"
                  v-model="lecData.lecEduDateTemplList[0].eduStartDate"
                >
                  <input type="text" :value="lecData.lecEduDateTemplList[0].eduStartDate" />
                </VueCtkDateTimePicker>
              </span>
              <span class="text-center w20">~</span>
              <span class="date">
                <VueCtkDateTimePicker
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :no-header="true"
                  :format="'YYYY-MM-DD'"
                  :only-date="true"
                  :minute-interval="10"
                  v-model="lecData.lecEduDateTemplList[0].eduEndDate"
                >
                  <input type="text" :value="lecData.lecEduDateTemplList[0].eduEndDate" />
                </VueCtkDateTimePicker>
              </span>
            </div>
          </div>
          <p class="f-12 m-b-0">교육기간</p>
          <div class="input-group full-width">
            <span class="input-group-addon clearfix">
              <input
                class="form-control-sm m-b-0 round pull-left"
                type="text"
                v-model="lecData.eduDay"
              />
              <span class="pull-left m-l-5">일</span>
            </span>
          </div>
          <p class="f-12 m-b-0">수업시간</p>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="edu_duration_opt1"
                class="checkbox3-sm"
                type="radio"
                value="0"
                v-model="lecData.eduDuration"
              />
              <label for="edu_duration_opt1" class="v-mid full-width m-0">상시</label>
            </span>
            <span class="input-group-addon p-l-5 w140 v-mid">
              <input
                id="edu_duration_opt2"
                class="checkbox3-sm"
                type="radio"
                value="40"
                v-model="lecData.eduDuration"
              />
              <label for="edu_duration_opt2" class="v-mid full-width m-0">40분</label>
            </span>
            <span class="input-group-addon p-l-5 w140 v-mid">
              <input
                id="edu_duration_opt3"
                class="checkbox3-sm"
                type="radio"
                value="60"
                v-model="lecData.eduDuration"
              />
              <label for="edu_duration_opt3" class="v-mid full-width m-0">60분</label>
            </span>
            <span class="input-group-addon p-l-5 w140 v-mid">
              <input
                id="edu_duration_opt4"
                class="checkbox3-sm"
                type="radio"
                value="90"
                v-model="lecData.eduDuration"
              />
              <label for="edu_duration_opt4" class="v-mid full-width m-0">90분</label>
            </span>
            <span class="input-group-addon p-l-5 w140 v-mid">
              <input
                id="edu_duration_opt5"
                class="checkbox3-sm"
                type="radio"
                value="120"
                v-model="lecData.eduDuration"
              />
              <label for="edu_duration_opt5" class="v-mid full-width m-0">120분</label>
            </span>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='수강생 신청'">
          <p class="f-14 m-b-5 pull-left m-b-10">정원</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk_eduperiodtype_2_fixednum"
                class="checkbox3-sm"
                type="checkbox"
                name="eduFixedNum"
                :checked="lecData.lecEduDateTemplList[0].eduFixedNum!==0"
                @change="$event.target.checked===false?lecData.lecEduDateTemplList[0].eduFixedNum=0:''"
              />
              <label for="chk_eduperiodtype_2_fixednum" class="v-mid full-width m-0">정원있음</label>
            </span>
            <span class="input-group-addon p-l-5 clearfix">
              <input
                class="form-control-sm m-b-0 round pull-left"
                type="text"
                v-model="lecData.lecEduDateTemplList[0].eduFixedNum"
              />
              <span class="pull-left">(신청)건</span>
            </span>
          </div>
        </div>

        <!-- 일정선택을 클릭했을때 노출 -->
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='일정 선택'">
          <p class="f-14 m-b-5 pull-left m-b-10">신청기간</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <p class="f-12 m-b-0">신청시작일</p>
          <div class="level m-b-0">
            <div class="level-form w300">
              <div class="level-form w300">
                <span class="date">
                  <VueCtkDateTimePicker
                    :no-value-to-custom-elem="true"
                    :no-button-now="true"
                    :no-header="true"
                    :format="'YYYY-MM-DD HH:mm'"
                    :minute-interval="10"
                    v-model="lecData.applStartDate"
                  >
                    <input type="text" :value="lecData.applStartDate" />
                  </VueCtkDateTimePicker>
                </span>
              </div>
            </div>
          </div>
          <p class="f-12 m-b-0">신청옵션</p>
          <div class="input-group m-b-5 full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk_eduperiodtype_3_applopt_1"
                class="checkbox3-sm"
                type="checkbox"
                name="applOpt1"
                v-model="lecData.applOpt.find(e=>e.name=='교육일자 기준').enabled"
              />
              <label for="chk_eduperiodtype_3_applopt_1" class="v-mid full-width m-0">교육일자 기준</label>
            </span>
            <span class="input-group-addon p-l-5 v-mid clearfix">
              <span class="pull-left m-l-5">교육시작일의</span>
              <input
                class="form-control-sm w80 m-l-5 m-b-0 round pull-left"
                type="text"
                v-model="lecData.applOpt.find(e=>e.name=='교육일자 기준').value"
              />
              <span class="pull-left m-l-5">일 전 까지</span>
            </span>
          </div>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input
                id="chk_eduperiodtype_3_applopt_2"
                class="checkbox3-sm"
                type="checkbox"
                name="applOpt2"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').enabled"
              />
              <label for="chk_eduperiodtype_3_applopt_2" class="v-mid full-width m-0">교육월 기준</label>
            </span>
            <span class="input-group-addon p-l-5 v-mid clearfix">
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').fromMonth"
              >
                <option value="지난달">지난달</option>
                <option value="지지난달">지지난달</option>
                <option value="3달전">3달전</option>
              </select>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').fromDate"
              >
                <option
                  v-for="(v,idx) in new Array(31)"
                  :key="'date-key-3-'+idx"
                  :value="idx+1"
                >{{idx+1}}일</option>
              </select>
              <span class="pull-left m-l-5">부터</span>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').toMonth"
              >
                <option value="지난달">지난달</option>
                <option value="지지난달">지지난달</option>
                <option value="3달전">3달전</option>
              </select>
              <select
                class="form-control-sm m-l-5 m-b-0 round pull-left"
                v-model="lecData.applOpt.find(e=>e.name=='교육월 기준').toDate"
              >
                <option
                  v-for="(v,idx) in new Array(31)"
                  :key="'date-key-4-'+idx"
                  :value="idx+1"
                >{{idx+1}}일</option>
              </select>
              <span class="pull-left m-l-5">까지</span>
            </span>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='일정 선택'">
          <p class="f-14 m-b-5">신청 안내</p>
          <div class="round">
            <textarea class="full-width" cols="30" rows="10" v-model="lecData.applGuide"></textarea>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='일정 선택'">
          <p class="f-14 m-b-5 pull-left m-b-10">교육일정 설정</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <p class="f-12 m-b-0">교육일수</p>
          <div class="input-group full-width m-b-10">
            <span class="input-group-addon clearfix">
              <input
                class="form-control-sm m-b-0 round pull-left"
                type="text"
                v-model="lecData.eduDay"
              />
              <span class="pull-left m-l-5">일</span>
            </span>
          </div>
        </div>
        <div class="white-box clearfix" v-if="lecData.eduPeriodType=='일정 선택'">
          <p class="f-14 m-b-5">정원</p>
          <div class="input-group full-width">
            <span class="input-group-addon w140 v-mid">
              <input id="check-1" class="checkbox3-sm" type="checkbox" name="student" />
              <label for="check-1" class="v-mid full-width m-0">정원있음</label>
            </span>
            <span class="input-group-addon p-l-5 clearfix">
              <input class="form-control-sm m-b-0 round pull-left" type="text" />
              <span class="pull-left">(신청)건</span>
            </span>
          </div>
        </div>

        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">교육 안내</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="round">
            <textarea class="full-width" cols="30" rows="10" v-model="lecData.eduGuide"></textarea>
          </div>
        </div>

        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">신청 양식 | 증명서 양식</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">신청양식 선택</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group full-width">
            <span class="input-group-addon p-r-5">
              <select class="form-control-sm m-b-0 round full-width" v-model="lecData.applForm">
                <option value>=== 신청양식 선택 ===</option>
                <option value="온라인">온라인 기본</option>
                <option value="찾아가는 국어문화학교">찾아가는 국어문화학교</option>
                <option value="원내">원내 기본</option>
                <option value="우리말 꿈터">우리말 꿈터</option>
                <option value="쏙!쏙! 국어교실">쏙!쏙! 국어교실</option>
              </select>
            </span>
            <span class="input-group-addon w200 v-mid">
              <button class="btn-sm bg-blue text-white round full-width" type="button">미리보기</button>
            </span>
          </div>
        </div>

        <div class="white-box head on-border bg-lightgray clearfix">
          <p class="f-16 m-b-0 pull-left">수업계획표 업로드</p>
          <!--
					<div class="input-group w120 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">전체숨김</label>
							</div>
						</span>
					</div>
          -->
        </div>
        <div class="white-box clearfix">
          <p class="f-14 m-b-5 pull-left m-b-10">수업계획표 등록</p>
          <!--
					<div class="input-group w60 pull-right">
						<span class="input-group-addon">
							<div class="checkbox full-width">
								<input id="chek2" type="checkbox">
								<label for="chek2" class="s-lineH round v-mid">숨김</label>
							</div>
						</span>
					</div>
          -->
          <div class="clearfix"></div>
          <div class="input-group full-width">
            <span class="input-group-addon p-r-5">
              <div class="search-box full-width v-mid">
                <input
                  id="file_plan"
                  type="file"
                  style="display: none;"
                  ref="file_plan"
                  @change="uploadPlan"
                />
                <input
                  id="file-text"
                  class="form-control-sm round full-width m-b-0"
                  type="text"
                  placeholder="파일명"
                  v-model="lesPlanFileName"
                  disabled
                />
              </div>
            </span>
            <span class="input-group-addon w120 p-r-5">
              <label for="file_plan" class="btn-sm round full-width">업로드</label>
            </span>
          </div>
        </div>
      </div>
    </section>

    <modal-confirm
      :config="modals.ModalConfirm"
      :key="hash(modals.ModalConfirm)"
      @yes="modals.ModalConfirm.show=false"
      @no="modals.ModalConfirm.show=false"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      :key="hash(modals.ModalAlert)"
      @close="modals.ModalAlert.show=false"
    ></modal-alert>

    <common-footer></common-footer>
  </fragment>
</template>

<script>
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CommonSideMenu from "../components/CommonSideMenu.vue";

import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";

import axios from "axios";
import server from "../statics/server.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  // 컴포넌트 명칭
  name: "ViewClassDefault",
  mixins: [fnAdjustHeight],

  // 이 컴포넌트에서 사용할 자식컴포넌트
  components: {
    CommonHeader,
    CommonFooter,
    CommonSideMenu,
    ModalAlert,
    ModalConfirm,
    VueCtkDateTimePicker
  },

  // 이 컴포넌트가 마운트되었을 떄의 처리
  mounted: function() {
    // 카테고리 목록 조회하고 첫번째 카테고리를 선택
    this.getCategoryData();
    // 직업목록 조회
    axios
      .post(server.addr() + server.api.COMMON_CODE, { codeId: "FIL001" })
      .then(response => {
        this.jobs_ = response.data.list.map(e => {
          e.isSelected = false;
          return e;
        });
      });
    // 관리자목록 조회
    axios
      .post(server.addr() + server.api.MBER, { adminEnable: 1 })
      .then(response => {
        this.admins_ = response.data.list;
      });
    // 강사목록 조회
    axios
      .post(server.addr() + server.api.MBER, { instEnable: 1 })
      .then(response => {
        this.teachers_ = response.data.list;
      });
  },

  // 이 컴포넌트에서 사용할 내부데이터
  data: function() {
    return {
      menus: [
        // 서브메뉴
        { name: "강좌 분류", link: "/categories", selected: false },
        { name: "강좌개설 초기값", link: "/default", selected: true },
        { name: "신청안내 설정", link: "/guides/apply", selected: false }
      ],
      buttons: [], // 헤더버튼
      modals: {
        ModalConfirm: ModalConfirm.default(),
        ModalAlert: ModalAlert.default()
      },
      side_menus: [],
      selectedCategory: null,
      selectedJob: -1,
      teacher_keyword: "",
      isFocus: false,
      lesPlanFileName: "",
      jobs_: [],
      admins_: [],
      teachers_: [],
      lecData: {
        lecTemplId: 0, // 강좌양식ID
        templStreEnable: 0, // 임시저장여부 (1이면 임시저장)
        categoryId: 0, // 카테고리 목록중 seq
        lecName: "", // 강의명
        lecIcon: "", // 강의아이콘 파일

        classroomOpt: "", // 강의실옵션 (JSON 문자열)
        goal: "", // 강의목표
        content: "", // 강의내용

        lesTargetWork: "", // 교육대상 (직업코드 문자열 CSV)

        lesTargetType: "", // 교육대상 분류 (개인/단체)
        lesTargetDetail: "", // 교육대상 상세
        inCharge: "", // 관리담당자 (관리자 회원목록중 seq)
        instAllotType: "", // 강사 분류 (강사없음/강사지정/신청후배정)
        eduTemplList: [], // 강사목록

        applForm: "", // 수강 신청양식 목록중 seq
        certForm: "", // 수료증양식 목록중 seq

        applStartDate: null,
        applEndDate: null,
        applOpt: [
          { name: "교육일자 기준", enabled: false, value: 0 },
          {
            name: "교육월 기준",
            enabled: false,
            fromMonth: "지난달",
            fromDate: 1,
            toMonth: "지난달",
            toDate: 31
          }
        ],
        eduPeriodType: "", // "교육일 지정" or "수강생 신청" or "일정 선택"
        eduDuration: 0,
        eduDay: 0,
        lecEduDateTemplList: [
          {
            eduStartDate: null,
            eduEndDate: null,
            eduStartTime: null,
            eduEndTime: null,
            eduDuration: "",
            eduFixedNum: 0
          }
        ],
        applGuide: "", // 신청안내
        eduGuide: "", // 교육 안내

        lesPlanFile: "", // 강의계획서 파일
        lesPlanNotExists: false // 강의계획서가 없는지 여부
      }
    };
  },

  // 내부데이터 변경감지
  watch: {
    selectedCategory: function() {
      // eslint-disable-next-line
      console.log("selectedCategory 변경되었음");
      axios
        .post(server.addr() + server.api.LECTURE_TEMPLATE, {
          categoryId: this.selectedCategory.categoryId
        })
        .then(response => {
          if (response.data.return) {
            let responseObj = response.data.return;
            responseObj.applOpt = JSON.parse(responseObj.applOpt);
            if (parseInt(responseObj.applStartDate) > 0)
              responseObj.applStartDate = moment(
                responseObj.applStartDate
              ).format("YYYY-MM-DD HH:mm:SS");
            if (parseInt(responseObj.applEndDate) > 0)
              responseObj.applEndDate = moment(responseObj.applEndDate).format(
                "YYYY-MM-DD HH:mm:SS"
              );
            this.lecData = responseObj;
          } else {
            // eslint-disable-next-line
            console.log("리턴값이 없으므로 새 객체를 만듬");
            this.lecData = {
              lecTemplId: 0, // 강좌양식ID
              templStreEnable: 0, // 임시저장여부 (1이면 임시저장)
              categoryId: this.selectedCategory.categoryId, // 카테고리 목록중 seq
              lecName: "", // 강의명
              lecIcon: "", // 강의아이콘 파일

              classroomOpt: "", // 강의실옵션 (JSON 문자열)
              goal: "", // 강의목표
              content: "", // 강의내용

              lesTargetWork: "", // 교육대상 (직업코드 문자열 CSV)

              lesTargetType: "", // 교육대상 분류 (개인/단체)
              lesTargetDetail: "", // 교육대상 상세
              inCharge: "", // 관리담당자 (관리자 회원목록중 seq)
              instAllotType: "", // 강사 분류 (강사없음/강사지정/신청후배정)
              eduTemplList: [], // 강사목록

              applForm: "", // 수강 신청양식 목록중 seq
              certForm: "", // 수료증양식 목록중 seq

              applStartDate: null,
              applEndDate: null,
              applOpt: [
                { name: "교육일자 기준", enabled: false, value: 0 },
                {
                  name: "교육월 기준",
                  enabled: false,
                  fromMonth: "지난달",
                  fromDate: 1,
                  toMonth: "지난달",
                  toDate: 31
                }
              ],
              eduPeriodType: "", // "교육일 지정" or "수강생 신청" or "일정 선택"
              eduDuration: 0,
              eduDay: 0,
              lecEduDateTemplList: [
                {
                  eduStartDate: null,
                  eduEndDate: null,
                  eduStartTime: null,
                  eduEndTime: null,
                  eduDuration: "",
                  eduFixedNum: 0
                }
              ],
              applGuide: "", // 신청안내
              eduGuide: "", // 교육 안내

              lesPlanFile: "", // 강의계획서 파일
              lesPlanNotExists: false // 강의계획서가 없는지 여부
            };
          }
        })
        .catch(() => {
          // eslint-disable-next-line
          console.log("통신에 실패했으므로 새 객체를 만듬");
          this.lecData = {
            lecTemplId: 0, // 강좌양식ID
            templStreEnable: 0, // 임시저장여부 (1이면 임시저장)
            categoryId: this.selectedCategory.categoryId, // 카테고리 목록중 seq
            lecName: "", // 강의명
            lecIcon: "", // 강의아이콘 파일

            classroomOpt: "", // 강의실옵션 (JSON 문자열)
            goal: "", // 강의목표
            content: "", // 강의내용

            lesTargetWork: "", // 교육대상 (직업코드 문자열 CSV)

            lesTargetType: "", // 교육대상 분류 (개인/단체)
            lesTargetDetail: "", // 교육대상 상세
            inCharge: "", // 관리담당자 (관리자 회원목록중 seq)
            instAllotType: "", // 강사 분류 (강사없음/강사지정/신청후배정)
            eduTemplList: [], // 강사목록

            applForm: "", // 수강 신청양식 목록중 seq
            certForm: "", // 수료증양식 목록중 seq

            applStartDate: null,
            applEndDate: null,
            applOpt: [
              { name: "교육일자 기준", enabled: false, value: 0 },
              {
                name: "교육월 기준",
                enabled: false,
                fromMonth: "지난달",
                fromDate: 1,
                toMonth: "지난달",
                toDate: 31
              }
            ],
            eduPeriodType: "", // "교육일 지정" or "수강생 신청" or "일정 선택"
            eduDuration: 0,
            eduDay: 0,
            lecEduDateTemplList: [
              {
                eduStartDate: null,
                eduEndDate: null,
                eduStartTime: null,
                eduEndTime: null,
                eduDuration: "",
                eduFixedNum: 0
              }
            ],
            applGuide: "", // 신청안내
            eduGuide: "", // 교육 안내

            lesPlanFile: "", // 강의계획서 파일
            lesPlanNotExists: false // 강의계획서가 없는지 여부
          };
        });
    }
  },

  // 이 컴포넌트에서 구현할 기능
  methods: {
    // 대분류 데이터 가져오기
    getCategoryData: async function() {
      try {
        const { data } = await axios.post(
          `${server.addr()}${server.api.CATEGORY_ALL}`,
          {}
        );
        data.list = data.list.map(category => {
          if (!category.applGuideList || category.applGuideList.length == 0)
            category.applGuideList = [{ content: "", title: "" }];
          return category;
        });
        this.side_menus = data.list
          .filter(ele => ele.parentsId === 0)
          .map(value => {
            if (!this.selectedCategory) this.selectedCategory = value; // 가장 첫번째 category를 선택하게 해둔다.
            const sub_menus = value.child.map(ele => {
              ele.applGuideList = [{ content: "", title: "" }];
              return {
                name: ele.name,
                fn: this.selectCategory(ele),
                category: ele
              };
            });
            return {
              category: value,
              name: value.name,
              sub_menus,
              fn: this.selectCategory(value),
              selected: value === this.selectedCategory
            };
          });
      } catch (e) {
        this.modals.ModalAlert.msg = "서버 오류입니다.";
        this.modals.ModalAlert.show = true;
      }
    },
    selectCategory: function(category) {
      return () => {
        this.selectedCategory = category;
        this.side_menus = this.side_menus.map(menu => {
          if (category === menu.category) menu.selected = true;
          else menu.selected = false;
          if (menu.sub_menus) {
            menu.sub_menus = menu.sub_menus.map(sub_menu => {
              if (category === sub_menu.category) sub_menu.selected = true;
              else sub_menu.selected = false;
              return sub_menu;
            });
          }
          return menu;
        });
      };
    },
    upload: function() {
      const formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      axios
        .post(`${server.addr()}${server.api.FILE}`, formData)
        .then(response => {
          this.lecData.lecIcon = response.data;
        });
    },
    uploadPlan: function() {
      this.lesPlanFileName = "업로드하는 중...";
      const formData = new FormData();
      formData.append("file", this.$refs.file_plan.files[0]);
      axios
        .post(`${server.addr()}${server.api.FILE}`, formData)
        .then(response => {
          this.lecData.lesPlanFile = response.data;
          this.lesPlanFileName = this.$refs.file_plan.files[0].name;
        });
    },
    save: function() {
      if (!this.selectedCategory) {
        this.modals.ModalAlert.msg = "먼저 강좌 분류를 선택해야 합니다.";
        this.modals.ModalAlert.show = true;
        return;
      }
      let sendData = { ...this.lecData };
      sendData.applOpt = JSON.stringify(sendData.applOpt);
      axios
        .patch(server.addr() + server.api.LECTURE_TEMPLATE, sendData)
        .then(response => {
          if (response.status == 200) {
            this.modals.ModalAlert.msg = "저장되었습니다.";
            this.modals.ModalAlert.show = true;
          } else {
            this.modals.ModalAlert.msg = "서버와 통신에 실패했습니다.";
            this.modals.ModalAlert.show = true;
          }
        });
    },
    changeClassroomOpt: function(optName) {
      if (this.lecData.classroomOpt.indexOf(optName) >= 0) {
        this.lecData.classroomOpt = this.lecData.classroomOpt
          .split(",")
          .filter(e => e != optName)
          .join(",");
      } else {
        if (this.lecData.classroomOpt)
          this.lecData.classroomOpt += "," + optName;
        else this.lecData.classroomOpt = optName;
      }
    },
    addJob: function() {
      if (this.selectedJob != -1) {
        this.jobs_[this.selectedJob].isSelected = true;
        if (this.lecData.lesTargetWork)
          this.lecData.lesTargetWork += "," + this.jobs_[this.selectedJob].code;
        else this.lecData.lesTargetWork = this.jobs_[this.selectedJob].code;
      }
      this.selectedJob = -1;
    },
    removeJob: function(job) {
      job.isSelected = false;
      this.lecData.lesTargetWork = this.lecData.lesTargetWork
        .split(",")
        .map(e => e != job.code)
        .join(",");
    },
    appendTeacher: function(teacher) {
      if (this.lecData.eduTemplList.indexOf(teacher) == -1)
        this.lecData.eduTemplList.push(teacher);
      this.isFocus = false;
    }
  },

  computed: {
    filteredTeachers: function() {
      return this.teachers_.filter(
        t =>
          (t.mberName && t.mberName.indexOf(this.teacher_keyword) !== -1) ||
          (t.mobileNum && t.mobileNum.indexOf(this.teacher_keyword) !== -1) ||
          (t.phoneNum && t.phoneNum.indexOf(this.teacher_keyword) !== -1)
      );
    }
  }
};
</script>